<template>
  <div class="security">
    <div class="title">账户安全</div>
    <div class="changePassword">
      <div class="header">
        <i class="el-icon-lock" style="font-size: 25px"></i>
        <span>修改密码</span>
      </div>
      <div class="bigText">定期修改密码</div>
      <div class="text">
        安全性高的密码可以使帐号更安全。建议您设置一个包含字母、符号或数字中至少两项且长度超过6位的密码。
      </div>
      <div class="button" @click="editPwd">修改密码</div>
    </div>
    <div class="changePassword">
      <div class="header">
        <i class="el-icon-mobile-phone" style="font-size: 25px"></i>
        <span>修改手机号码</span>
      </div>
      <div class="text">
        该手机号码将用于登录平台、找回密码、接收平台重要通知，请妥苦保管。
      </div>
      <div class="button" @click="showDialog = true">修改手机</div>
    </div>
    <el-dialog
      title="修改手机号"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="closeDialog"
      width="600px"
      top="40vh"
    >
      <el-form
        :model="form"
        ref="form"
        class="demo-form-inline"
        label-width="100px"
        :rules="rules"
      >
        <el-form-item label="手机号码" prop="phone">
          <el-input
            v-model="form.phone"
            style="width: 300px; margin-right: 10px"
            placeholder="请输入内容"
            :maxlength="11"
          ></el-input>
          <el-button
            class="button"
            @click="getCodes"
            style="background: #1366ec; color: #fff; border: 1px solid #1366ec"
            :disabled="form.phone.length != 11"
            >{{ codeText }}</el-button
          >
        </el-form-item>
        <el-form-item label="验证码" prop="code">
          <el-input
            v-model="form.code"
            style="width: 300px"
            :maxlength="6"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="changePhone"
          style="background: #1366ec; border: 1px solid #1366ec"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 修改密码 -->
    <el-dialog
      :title="modifyPwdDialog.title"
      :visible.sync="modifyPwdDialog.visible"
      :before-close="closeModifyPwdDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
      width="530px"
      :append-to-body="true"
      top="10vh"
    >
      <div>
        <el-form
          ref="modifyPwdForm"
          class="modifyPwd-form"
          autocomplete="off"
          :model="modifyPwdDialog"
          :rules="rules"
          label-width="80px"
        >
          <el-form-item prop="oldPassword" label="原密码">
            <el-input
              v-model="modifyPwdDialog.oldPassword"
              type="password"
              placeholder="原密码"
              :autofocus="true"
            />
          </el-form-item>
          <el-form-item prop="newPassword" label="新密码">
            <el-input
              v-model="modifyPwdDialog.newPassword"
              type="password"
              placeholder="新密码"
            />
          </el-form-item>
          <el-form-item prop="confirmPassword" label="确认密码">
            <el-input
              v-model="modifyPwdDialog.confirmPassword"
              type="password"
              placeholder="确认密码"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeModifyPwdDialog">取 消</el-button>
        <el-button type="primary" @click="modifyPwd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { changePhone, getCode } from "./viewApi";
import { validateForm, validatePwd } from "@/utils";
import { modifyPwd } from "@/api/index";
import { rsaEncrypt } from "@/utils/jsencrypt";
import { formatDate } from "../../utils";
export default {
  data() {
    var validateConfirmPwd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value !== this.modifyPwdDialog.newPassword) {
        callback(new Error("确认密码和新密码不一致。"));
      } else {
        callback();
      }
    };
    return {
      showDialog: false,
      codeText: "获取验证码",
      isLoading: false,
      time: 60,
      modifyPwdDialog: {
        title: "修改密码",
        visible: false,
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      form: {
        phone: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: "请输入原密码",
            trigger: ["blur", "change"],
          },
        ],
        newPassword: [
          {
            required: true,
            message: "请输入新密码",
            trigger: ["blur", "change"],
          },
          { validator: validatePwd },
        ],
        confirmPassword: [
          {
            required: true,
            message: "请输入确认密码",
            trigger: ["blur", "change"],
          },
          {
            validator: validateConfirmPwd,
            trigger: ["blur", "change"],
          },
        ],
        phone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            pattern: /^1[0-9]{10}$/,
            message: "请正确输入11位手机号码",
            trigger: "blur",
          },
        ],
        code: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    modifyPwd() {
      if (!validateForm(this.$refs["modifyPwdForm"])) {
        message = "表单信息缺失。";
        this.$baseMessage(message, "error");
        return;
      }
      const params = {
        oldPassword: rsaEncrypt(this.modifyPwdDialog.oldPassword),
        newPassword: rsaEncrypt(this.modifyPwdDialog.newPassword),
      };
      modifyPwd(params).then((res) => {
        this.$baseMessage("修改密码成功，请重新登录。", "success");
        this.closeModifyPwdDialog();

        let userInfoweb = this.$store.state.system.userInfoweb;
        window.localStorage.removeItem('tokenweb');
        window.localStorage.removeItem('userInfoweb');

        this.$router.push({
          name: 'login',
          query: {
            type: (userInfoweb.type==4) ? 1 : 2,
          },
        });

      });
    },
    editPwd(){
      this.modifyPwdDialog.visible = true;
    },
    closeModifyPwdDialog() {
      this.modifyPwdDialog.visible = false;
    },
    getCodes() {
      if (this.isLoading) {
        return;
      }
      this.codeText = this.time + "秒";
      this.isLoading = true;
      getCode({ phone: this.form.phone }).then((res) => {
        this.$baseMessage("已发送", "success");
      });
      let timer = setInterval(() => {
        this.time--;
        this.codeText = this.time + "秒";

        if (this.time <= 0) {
          this.isLoading = false;
          this.time = 60;
          this.codeText = "获取验证码";
          clearInterval(timer);
          timer = null;
        }
      }, 1000);
    },
    closeDialog() {
      this.showDialog = false;
    },
    changePhone() {
      if (!validateForm(this.$refs["form"])) {
        return;
      }
      this.$confirm(`确认修改手机号码吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((_) => {
        const params = new FormData();
        params.append("phone", this.form.phone);
        params.append("code", this.form.code);
        changePhone(params).then((res) => {
          this.$baseMessage("修改成功。", "success");
          this.closeDialog();
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.security {
  height: 100%;
  background: white;
  border-radius: 16px;
  padding: 10px;
  .title {
    border-bottom: 1px solid #ccc;
    line-height: 40px;
    padding: 0 10px;
    font-weight: bold;
    margin-bottom: 20px;
    text-align: left;
  }
  .changePassword {
    position: relative;
    margin-bottom: 20px;
    line-height: 40px;
    color: #000;
    .header {
      font-weight: bold;
      line-height: 40px;
      font-size: 18px;
      span {
        margin-left: 10px;
      }
    }
    .text {
      font-size: 14px;
    }
    .button {
      position: absolute;
      right: 0;
      bottom: 0;
      line-height: 20px;
    }
  }
}
.button {
  display: inline-block;
  border: 1px solid #1366ec;
  padding: 5px 15px;
  border-radius: 5px;
  color: #fff;
  background: #1366ec;
  cursor: pointer;
  line-height: 20px;
}
</style>